<template>
  <div>
    <div class="page-header">
      <h1 class="page-title">Confirmados</h1>
      <span class="counter-badge" v-if="store.confirmedCount">{{ store.confirmedCount }} participantes</span>
    </div>

    <SkeletonLoader v-if="store.loading" variant="card" :count="6" />

    <div class="confirmed-grid" v-else-if="store.confirmed.length > 0">
      <div class="confirmed-card card" v-for="item in store.confirmed" :key="item.id" @click="openDetail(item)">
        <div class="card-top">
          <span class="card-name">{{ item.name }}</span>
          <StatusBadge status="confirmed" />
        </div>
        <span class="card-leader">{{ item.leader }}</span>
        <div class="card-bottom">
          <span>{{ item.city || '-' }}</span>
          <span>{{ item.age }} anos</span>
        </div>
      </div>
    </div>

    <EmptyState v-else title="Nenhum confirmado" description="Faca o check-in dos participantes para ve-los aqui." />

    <!-- Modal Detalhes -->
    <div class="modal-overlay" v-if="selected" @click.self="selected = null">
      <div class="modal-card">
        <h2 class="modal-title">{{ selected.name }}</h2>

        <div class="detail-grid">
          <div class="detail-item"><span class="detail-label">Lider</span><span class="detail-value">{{ selected.leader }}</span></div>
          <div class="detail-item"><span class="detail-label">Idade</span><span class="detail-value">{{ selected.age }}</span></div>
          <div class="detail-item"><span class="detail-label">Telefone</span><span class="detail-value">{{ selected.number || '-' }}</span></div>
          <div class="detail-item"><span class="detail-label">Tel. Responsavel</span><span class="detail-value">{{ selected.numberFamily || '-' }}</span></div>
          <div class="detail-item"><span class="detail-label">Cidade</span><span class="detail-value">{{ selected.city || '-' }}</span></div>
          <div class="detail-item"><span class="detail-label">Igreja</span><span class="detail-value">{{ selected.church || '-' }}</span></div>
          <div class="detail-item"><span class="detail-label">Volumes</span><span class="detail-value">{{ selected.baggage || 0 }}</span></div>
          <div class="detail-item"><span class="detail-label">Alergia</span><span class="detail-value">{{ selected.allergy || 'Nenhuma' }}</span></div>
        </div>

        <div class="qr-wrapper">
          <QrCodeDisplay :value="selected.id" :size="150" label="QR Check-in" />
        </div>

        <div class="modal-actions">
          <button class="btn-secondary" @click="selected = null">Fechar</button>
          <button class="btn-danger" @click="handleUndo">Desfazer Check-in</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useParticipantsStore } from '../stores/participants'
import StatusBadge from '../components/ui/StatusBadge.vue'
import SkeletonLoader from '../components/ui/SkeletonLoader.vue'
import EmptyState from '../components/ui/EmptyState.vue'
import QrCodeDisplay from '../components/QrCodeDisplay.vue'

export default {
  name: 'ConfirmedPage',
  components: { StatusBadge, SkeletonLoader, EmptyState, QrCodeDisplay },
  data() { return { selected: null } },
  computed: {
    store() { return useParticipantsStore() }
  },
  methods: {
    openDetail(item) { this.selected = { ...item } },
    async handleUndo() {
      try {
        await this.store.removeCheckin(this.selected.id)
        this.selected = null
      } catch {
        this.$toast.open({ message: 'Erro ao desfazer', type: 'error', position: 'top-right', duration: 5000 })
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-base);
  margin-bottom: var(--spacing-base);
}
.page-header .page-title { margin-bottom: 0; }
.counter-badge {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  background: var(--color-bg-hover);
  padding: 4px 12px;
  border-radius: 12px;
}
.confirmed-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: var(--spacing-base);
}
.confirmed-card {
  padding: var(--spacing-base);
  cursor: pointer;
  transition: var(--transition-default);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}
.confirmed-card:hover { transform: translateY(-3px); }
.card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-name {
  font-size: var(--text-md);
  font-weight: 600;
  color: var(--color-text-primary);
}
.card-leader {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
.card-bottom {
  display: flex;
  justify-content: space-between;
  font-size: var(--text-xs);
  color: var(--color-text-secondary);
  margin-top: auto;
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--color-bg-separator);
}
.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-base);
  margin-bottom: var(--spacing-base);
}
.detail-label {
  display: block;
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: var(--spacing-xs);
}
.detail-value {
  font-size: var(--text-base);
  color: var(--color-text-primary);
  font-weight: 600;
}
.qr-wrapper {
  display: flex;
  justify-content: center;
  margin: var(--spacing-base) 0;
}
</style>
